import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

export const Route = createFileRoute("/locations/restore-national")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/restore-northeast/", location.searchStr), statusCode: 301 });
  },
  component: () => null,
});
